"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderWrapperMobile = exports.LabelWrapperMobile = exports.InputLabel = exports.InputContainer = exports.SelectionContainer = exports.SelectionWrapper = exports.SliderContainer = void 0;

const styled_components_1 = __importStar(require("styled-components"));

exports.SliderContainer = styled_components_1.default.div`
  position: relative;
  height: 14px;
  padding: 7px 0 5px;
  width: ${props => props.withoutMarks ? 'calc(100% - 14px)' : '100%'};
  margin: 0 auto;
  border-radius: 2px;
  touch-action: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); //  remove tap highlight color for mobile safari
  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0); //  remove tap highlight color for mobile safari
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: ${props => props.railBg || props.theme.colors.gray_301};
    height: 2px;
    ${props => props.withoutMarks && (0, styled_components_1.css)`
        &:before,
        &:after {
          content: '';
          position: absolute;
          height: 2px;
          width: 7px;
          background-color: ${props.railBg || props.theme.colors.gray_301};
        }
        &:before {
          transform: translateX(-100%);
          border-top-left-radius: 2px;
          border-bottom-left-radius: 2px;
        }
        &:after {
          transform: translateX(100%);
          right: 0px;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
        }
      `}
  }

  .rc-slider-track {
    position: absolute;
    left: 0;
    height: 2px;
    border-radius: 2px;
    background-color: ${props => props.trackBg || props.theme.colors.primary_700_main};
    ${props => props.withoutMarks && (0, styled_components_1.css)`
        &:before {
          content: '';
          position: absolute;
          height: 2px;
          width: 7px;
          background-color: ${props.trackBg || props.theme.colors.primary_700_main};
          transform: translateX(-100%);
          border-radius: 2px 0 0 2px;
        }
      `}
  }

  .rc-slider-handle {
    position: absolute;
    width: 16px;
    height: 16px;
    cursor: pointer;
    cursor: -webkit-grab;
    touch-action: pan-x;
    margin-top: -7px;
    cursor: grab;
    border-radius: 50%;
    background-color: ${props => props.handleBg || props.theme.colors.white};
    outline: 0;
    &:before {
      content: '';
      position: absolute;
      height: 9px;
      width: 9px;
      border-radius: 50%;
      border: 2px solid ${props => props.handleBorder || props.theme.colors.primary_700_main};
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &-dragging {
      box-shadow: 0 0 5px #2d5dec4d;
    }

    /* &-click-focused:focus {
      box-shadow: 0px 0px 5px 3px #2d5dec4d;
    } */

    /* &:hover {
      box-shadow: 0px 0px 5px 3px #2d5dec4d;
    } */

    ${props => !props.theme.isMobile && (0, styled_components_1.css)`
        &:active {
          cursor: -webkit-grabbing;
          cursor: grabbing;
          box-shadow: 0px 0px 5px 3px #2d5dec4d;
        }
        &:focus {
          box-shadow: 0 0 5px 3px #2d5dec4d;
        }
      `}
  }

  .rc-slider-mark {
    position: absolute;
    top: 20px;
    left: 0;
    width: 100%;
    font-size: 9px;
  }

  .rc-slider-mark-text {
    position: absolute;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
    color: ${props => props.theme.colors.gray_301};
    white-space: nowrap;
    font-size: ${props => props.theme.fontSizes[12]};
    line-height: ${props => props.theme.lineHeights[16]};

    &-active {
      color: ${props => props.theme.colors.black_main};
    }
  }

  .rc-slider-step {
    position: absolute;
    width: 100%;
    height: 2px;
    background: transparent;
  }

  .rc-slider-dot {
    position: absolute;
    height: 2px;
    width: 1px;
    background: #fff;
  }

  .rc-slider-disabled {
    cursor: not-allowed;
    opacity: 0.5;

    .rc-slider-track {
      cursor: not-allowed;
    }

    .rc-slider-handle,
    .rc-slider-dot {
      cursor: not-allowed;
    }

    .rc-slider-mark-text,
    .rc-slider-dot {
      cursor: not-allowed;
    }
  }
  ${props => props.isMobile && (0, styled_components_1.css)`
      width: ${props.withoutMarks ? 'calc(100% - 36px)' : '100%'};

      .rc-slider-handle {
        width: 36px;
        height: 36px;
        margin-top: -18px;
        &:before {
          height: 24px;
          width: 24px;
          border-width: 3px;
        }
      }
      .rc-slider-handle-1:after,
      .rc-slider-handle-2:after {
        position: absolute;
        top: -20px;
        left: 0;
        right: 0;
        font-size: 13px;
        font-family: inherit;
        text-align: center;
        margin-left: 2px;
      }
      .rc-slider-step,
      .rc-slider-dot,
      .rc-slider-rail,
      .rc-slider-track {
        height: 3px;
      }
      .rc-slider-dot {
        width: 2px;
      }
      .rc-slider-dot:first-of-type,
      .rc-slider-dot:last-of-type {
        display: none;
      }
      .rc-slider-rail {
        ${props.withoutMarks && (0, styled_components_1.css)`
          &:before,
          &:after {
            content: '';
            position: absolute;
            height: 3px;
            width: 18px;
          }
          &:before {
            transform: translateX(-100%);
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
          }
          &:after {
            transform: translateX(100%);
            right: 0px;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
          }
        `}
      }
      .rc-slider-mark {
        top: 30px;
      }
    `}
`;
exports.SelectionWrapper = styled_components_1.default.div`
  display: flex;
  margin-bottom: 14px;
  align-items: flex-end;
`;
exports.SelectionContainer = styled_components_1.default.span`
  color: ${props => props.theme.colors.black_main};
  font-size: ${props => props.theme.fontSizes[16]};
  line-height: 21px;
  font-weight: ${props => props.theme.fontWeights[3]};
  margin: 0 auto 4px;
  letter-spacing: 0.5px;
  ${props => props.isMobile && (0, styled_components_1.css)`
      margin: 0;
      font-size: ${props.theme.fontSizes[18]};
      font-weight: ${props.theme.fontWeights[1]};
      line-height: 1;
    `}
`;
exports.InputContainer = styled_components_1.default.div`
  max-width: 70px;
  min-width: 70px;
  text-align: center;
`;
exports.InputLabel = styled_components_1.default.span`
  text-transform: uppercase;
  font-size: ${props => props.theme.fontSizes[10]};
  color: ${props => props.theme.colors.gray_602};
  line-height: ${props => props.theme.lineHeights[13]};
  margin-bottom: 4px;
  display: block;
`;
exports.LabelWrapperMobile = styled_components_1.default.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  align-items: center;
`;
exports.SliderWrapperMobile = styled_components_1.default.div`
  .rc-slider-handle-1:after {
    content: '${props => props.min}';
  }
  .rc-slider-handle-2:after {
    content: '${props => props.max}';
  }
`;